/* rhode accordion behavior — GSAP open/close for details.rhode-acc rows.
   Imported by any section that renders them; the browser dedupes the module,
   so it binds once no matter how many sections import it.
   One-at-a-time: wrap rows in a container with data-acc-single.
   Jitter fix: paddingBottom is tweened with height so the body doesn't pop. */
import { gsap } from 'https://cdn.jsdelivr.net/npm/gsap@3.13.0/+esm'

const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches

function closeAcc(d) {
  const body = d.querySelector('.rhode-acc__body')
  if (reduce || !body) {
    d.open = false
    return
  }
  gsap.to(body, {
    height: 0,
    paddingBottom: 0,
    opacity: 0,
    duration: 0.35,
    ease: 'power2.inOut',
    overwrite: true,
    onStart: () => gsap.set(body, { overflow: 'hidden' }),
    onComplete: () => {
      d.open = false
      gsap.set(body, { clearProps: 'all' })
    },
  })
}

document.querySelectorAll('details.rhode-acc').forEach((d) => {
  if (d.dataset.accInit) return
  d.dataset.accInit = '1'
  const summary = d.querySelector('summary')
  const body = d.querySelector('.rhode-acc__body')
  if (!summary || !body) return
  summary.addEventListener('click', (e) => {
    e.preventDefault()
    if (gsap.isTweening(body)) return
    if (d.open) {
      closeAcc(d)
      return
    }
    const group = d.closest('[data-acc-single]')
    if (group) {
      group.querySelectorAll('details.rhode-acc[open]').forEach((o) => {
        if (o !== d) closeAcc(o)
      })
    }
    d.open = true
    if (reduce) return
    gsap.from(body, {
      height: 0,
      paddingBottom: 0,
      opacity: 0,
      duration: 0.4,
      ease: 'power2.out',
      onStart: () => gsap.set(body, { overflow: 'hidden' }),
      onComplete: () => gsap.set(body, { clearProps: 'all' }),
    })
  })
})
